export interface Template {
  id: string;
  slug: string;
  name: string;
  description?: string;
  type: "email" | "pdf";
  category: string;
  typeLabel: string;
  categoryLabel: string;
  subject?: string;
  subjectSk?: string;
  content: string;
  contentSk?: string;
  variables?: string;
  isSystem: boolean;
  isActive: boolean;
  versionCount?: number;
}

export interface TemplateVersion {
  id: string;
  templateId: string;
  version: number;
  content: string;
  contentSk?: string;
  subject?: string;
  subjectSk?: string;
  changeNote?: string;
  createdBy?: string;
  createdAt: string;
}

export interface VariableInfo {
  key: string;
  label: string;
  description: string;
}

export const CATEGORIES = [
  { value: "newsletter", label: "Newsletter" },
  { value: "booking", label: "Booking confirmation" },
  { value: "payment", label: "Payments" },
  { value: "contract", label: "Contracts" },
  { value: "invoice", label: "Invoices" },
  { value: "voucher", label: "Vouchers" },
  { value: "other", label: "Other" },
];

export const TYPES = [
  { value: "email", label: "Email" },
  { value: "pdf", label: "PDF document" },
];
